import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Understanding from '../views/v1/Understanding.vue';
import ModelSetting from '../views/v1/ModelSetting.vue';
import Rulebased from '../views/Rulebased.vue';
import NLPConfig from '../views/NLPConfig.vue';
import OneChat from '../views/v1/OneChat.vue';
import LogsExport from '../views/LogsExport.vue';
import Promotions from '../views/Promotions.vue';
import UserManager from '../views/v1/UserManager.vue';
import ActivityLog from '../views/v1/Activitylog.vue';
import ValueEditor from '../views/KeyValue.vue';
import aliceApi from '../alice-api';
import dashboardConfig from '../dashboard-config';
import Satisfaction from '../views/Satisfaction.vue';
import NPS from '../views/NPS.vue';
import FAQReportExport from '../views/FAQReportExport.vue';
import PromotionTrackingReportExport from '../views/PromotionTrackingReportExport.vue';

Vue.use(VueRouter);

const { getConfig } = dashboardConfig;
let config = {};

const dashboardMenu = [
  {
    path: '',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'understanding',
    name: 'understanding',
    component: Understanding,
    // component: () => import(/* webpackChunkName: "Understanding" */ '../views/v1/Understanding.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'satisfaction',
    name: 'satisfaction',
    component: Satisfaction,
    // component: () => import(/* webpackChunkName: "Satisfaction" */ '../views/satisfaction.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/nps',
    name: 'nps',
    component: NPS,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'knowledge/model-setting',
    name: 'model_setting',
    component: ModelSetting,
    // component: () => import(/* webpackChunkName: "ModelSetting" */'../views/v1/ModelSetting.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'knowledge/rule-based',
    name: 'rulebased',
    component: Rulebased,
    // component: () => import(/* webpackChunkName: "Rulebased" */'../views/Rulebased.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'knowledge/nlp-config',
    name: 'nlpconfig',
    component: NLPConfig,
    // component: () => import(/* webpackChunkName: "NLPConfig" */'../views/NLPConfig.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/1-on-1-chat',
    name: 'one_on_one_chat',
    component: OneChat,
    // component: () => import(/* webpackChunkName: "OneChat" */'../views/v1/OneChat.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'tools/value-editor',
    name: 'value_editor',
    // component: () => import(/* webpackChunkName: "KeyValue" */'../views/KeyValue.vue'),
    component: ValueEditor,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'tools/export-logs',
    name: 'logs_export',
    component: LogsExport,
    // component: () => import(/* webpackChunkName: "LogsExport" */'../views/LogsExport.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'tools/faq-report-export',
    name: 'faq_report_export',
    component: FAQReportExport,
    // component: () => import(/* webpackChunkName: "FAQReportExport" */'../views/FAQReportExport.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'tools/promotions',
    name: 'promotions',
    component: Promotions,
    // component: () => import(/* webpackChunkName: "Promotions" */'../views/Promotions.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'tools/promotion-tracking-export',
    name: 'promotion_tracking_export',
    component: PromotionTrackingReportExport,
    // component: () => import(/* webpackChunkName: "FAQReportExport" */'../views/FAQReportExport.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'setting/user-manager',
    name: 'user_manager',
    component: UserManager,
    // component: () => import(/* webpackChunkName: "UserManager" */'../views/v1/UserManager.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/activitylog',
    name: 'activitylog',
    component: ActivityLog,
    meta: {
      requiresAuth: true,
    },
  },
];

// if (!config.understanding.isHide) {
//   dashboardMenu.push({
//     path: 'understanding',
//     name: 'understanding',
//     component: Understanding,
//     // component: () => import(/* webpackChunkName: "Understanding" */ '../views/v1/Understanding.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.satisfaction.isHide) {
//   dashboardMenu.push({
//     path: 'satisfaction',
//     name: 'satisfaction',
//     component: Satisfaction,
//     // component: () => import(/* webpackChunkName: "Satisfaction" */ '../views/satisfaction.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.knowledge.modelSetting.isHide) {
//   dashboardMenu.push({
//     path: 'knowledge/model-setting',
//     name: 'model_setting',
//     component: ModelSetting,
//     // component: () => import(/* webpackChunkName: "ModelSetting" */'../views/v1/ModelSetting.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.knowledge.rulebased.isHide) {
//   dashboardMenu.push({
//     path: 'knowledge/rule-based',
//     name: 'rulebased',
//     component: Rulebased,
//     // component: () => import(/* webpackChunkName: "Rulebased" */'../views/Rulebased.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.knowledge.nlpConfig.isHide) {
//   dashboardMenu.push({
//     path: 'knowledge/nlp-config',
//     name: 'nlpconfig',
//     component: NLPConfig,
//     // component: () => import(/* webpackChunkName: "NLPConfig" */'../views/NLPConfig.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.oneOnOneChat.isHide) {
//   dashboardMenu.push({
//     path: '/1-on-1-chat',
//     name: 'one_on_one_chat',
//     component: OneChat,
//     // component: () => import(/* webpackChunkName: "OneChat" */'../views/v1/OneChat.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.tools.valueEditor.isHide) {
//   dashboardMenu.push({
//     path: 'tools/value-editor',
//     name: 'value_editor',
//     // component: () => import(/* webpackChunkName: "KeyValue" */'../views/KeyValue.vue'),
//     component: ValueEditor,
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.tools.exportChatLogs.isHide) {
//   dashboardMenu.push({
//     path: 'tools/export-logs',
//     name: 'logs_export',
//     component: LogsExport,
//     // component: () => import(/* webpackChunkName: "LogsExport" */'../views/LogsExport.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.tools.promotions.isHide) {
//   dashboardMenu.push({
//     path: 'tools/promotions',
//     name: 'promotions',
//     component: Promotions,
//     // component: () => import(/* webpackChunkName: "Promotions" */'../views/Promotions.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.setting.userManager.isHide) {
//   dashboardMenu.push({
//     path: 'setting/user-manager',
//     name: 'user_manager',
//     component: UserManager,
//     // component: () => import(/* webpackChunkName: "UserManager" */'../views/v1/UserManager.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.activitylog.isHide) {
//   dashboardMenu.push({
//     path: '/activitylog',
//     name: 'activitylog',
//     component: ActivityLog,
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

// if (!config.nps.isHide) {
//   dashboardMenu.push({
//     path: '/nps',
//     name: 'nps',
//     component: NPS,
//     meta: {
//       requiresAuth: true,
//     },
//   });
// }

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    path: '/',
    component: () => import('../views/DashboardLayout.vue'),
    children: dashboardMenu,
  },
  {
    path: '/sandbox',
    name: 'sandbox',
    component: () => import('../views/dev/Sandbox.vue'),
  },
  { path: '*', redirect: '/' },
];

const basePath = aliceApi.appPath || process.env.BASE_URL;

const router = new VueRouter({
  mode: 'history',
  base: basePath,
  routes,
});

const isToPageInvalid = (toName) => {
  let isInvalid;

  if (toName === 'understanding' && config.understanding.isHide === true) {
    isInvalid = true;
  } else if (toName === 'satisfaction' && config.satisfaction.isHide === true) {
    isInvalid = true;
  } else if (toName === 'nps' && config.nps.isHide === true) {
    isInvalid = true;
  } else if (toName === 'model_setting' && config.knowledge.modelSetting.isHide === true) {
    isInvalid = true;
  } else if (toName === 'rulebased' && config.knowledge.rulebased.isHide === true) {
    isInvalid = true;
  } else if (toName === 'nlpconfig' && config.knowledge.nlpConfig.isHide === true) {
    isInvalid = true;
  } else if (toName === 'one_on_one_chat' && config.oneOnOneChat.isHide === true) {
    isInvalid = true;
  } else if (toName === 'value_editor' && config.tools.valueEditor.isHide === true) {
    isInvalid = true;
  } else if (toName === 'logs_export' && config.tools.exportChatLogs.isHide === true) {
    isInvalid = true;
  } else if (toName === 'faq_report_export' && config.tools.exportFaqReport.isHide === true) {
    isInvalid = true;
  } else if (toName === 'promotion_tracking_export' && config.tools.exportPromotionTracking.isHide === true) {
    isInvalid = true;
  } else if (toName === 'promotions' && config.tools.promotions.isHide === true) {
    isInvalid = true;
  } else if (toName === 'user_manager' && config.setting.userManager.isHide === true) {
    isInvalid = true;
  } else if (toName === 'activitylog' && config.activitylog.isHide === true) {
    isInvalid = true;
  } else {
    isInvalid = false;
  }

  return isInvalid;
};

router.beforeEach(async (to, from, next) => {
  config = await getConfig();

  const toName = to.name;
  if (isToPageInvalid(toName) === true) {
    next({ name: 'home' });
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem('accessToken') === null) {
      next({
        path: '/login',
      });
    } else {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user.role) {
          if (aliceApi.hasPermission(user.role, to.name)) {
            next();
          } else {
            next({ name: 'home' });
          }
        } else {
          // console.error('USER ROLE MISSING');
          next({
            path: '/login',
          });
        }
      } catch (e) {
        aliceApi.logout();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem('accessToken') === null) {
      next();
    } else {
      next({ name: 'home' });
    }
  } else {
    next();
  }
});
export default router;

// children: [
//   {
//     path: '',
//     name: 'home',
//     component: () => import('../views/Home.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'understanding',
//     name: 'understanding',
//     component: () => import('../views/v1/Understanding.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'model',
//     name: 'model',
//     component: () => import('../views/Model.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'storyboard',
//     name: 'storyboard',
//     component: () => import('../views/Storyboard.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'storyboard/:stateId/:conditionId+',
//     name: 'condition',
//     component: () => import('../views/Condition.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   // {
//   //   path: 'knowledge/train',
//   //   name: 'train',
//   //   component: () => import('../views/v1/Train.vue'),
//   //   meta: {
//   //     requiresAuth: true,
//   //   },
//   // },
//   {
//     path: 'knowledge/rule-based',
//     name: 'rulebased',
//     component: () => import('../views/Rulebased.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'knowledge/nlp-config',
//     name: 'nlpconfig',
//     component: () => import('../views/NLPConfig.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'knowledge/model-setting',
//     name: 'model_setting',
//     component: () => import('../views/v1/ModelSetting.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'knowledge/benchmark',
//     name: 'benchmark',
//     component: () => import('../views/v1/Benchmark.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: '/1-on-1-chat',
//     name: 'one_on_one_chat',
//     component: () => import('../views/v1/OneChat.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'tools/export-logs',
//     name: 'logs_export',
//     component: () => import('../views/LogsExport.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'tools/promotions',
//     name: 'promotions',
//     component: () => import('../views/Promotions.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'tools/value-editor',
//     name: 'value_editor',
//     component: () => import('../views/KeyValue.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'tools/test-set-editor',
//     name: 'test_set_editor',
//     component: () => import('../views/TestSet.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'tools/conversation-editor',
//     name: 'conversation_editor',
//     component: () => import('../views/v1/ConversationEditor.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
//   {
//     path: 'setting/user-manager',
//     name: 'user_manager',
//     component: () => import('../views/v1/UserManager.vue'),
//     meta: {
//       requiresAuth: true,
//     },
//   },
// ]
